const magnitude = value =>
  Math.floor(Math.log10(Math.abs(value)));

export default magnitude;